'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _deepEqual = require('deep-equal');

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _condenseKeys = require('condense-keys');

var _condenseKeys2 = _interopRequireDefault(_condenseKeys);

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _objectAssign = require('object-assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _swiper = require('swiper');

var _swiper2 = _interopRequireDefault(_swiper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
	arrows: {
		type: 'boolean'
	},
	class: {
		type: 'string'
	},
	direction: {
		type: 'string'
	},
	disableOnInteraction: {
		type: 'boolean'
	},
	duration: {
		type: 'number'
	},
	effect: {
		type: 'string'
	},
	iconNext: {
		type: 'string'
	},
	iconPrev: {
		type: 'string'
	},
	loop: {
		type: 'boolean'
	},
	maintenance: {
		type: 'boolean'
	},
	onInit: {
		type: 'function'
	},
	options: {
		type: 'object'
	},
	pagination: {
		type: 'boolean'
	},
	paginationType: {
		type: 'string'
	},
	play: {
		type: 'boolean'
	},
	speed: {
		type: 'boolean'
	},
	timing: {
		type: 'string'
	}
}; /** @jsx dom */


var defaultProps = {
	duration: 2000,
	direction: 'horizontal',
	effect: 'slide',
	loop: false,
	maintenance: false,
	onInit: function onInit() {},
	play: false,
	speed: 3000,
	timing: 'ease'
};

var initialState = function initialState() {
	return {
		active: 0
	};
};

var getArrows = function getArrows(id, _ref) {
	var arrows = _ref.arrows,
	    iconNext = _ref.iconNext,
	    iconPrev = _ref.iconPrev,
	    styleClasses = _ref.styleClasses;
	return arrows && (0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['swiper-controls', styleClasses && styleClasses.Slideshow_Controls], 'data-style-attr': 'Slideshow_Controls' },
		(0, _magicVirtualElement2.default)(
			'div',
			{ id: id + '-swiper-button-prev', 'class': ['swiper-button-prev', iconPrev && 'swiper-no-arrow', styleClasses && styleClasses.Slideshow_Arrow_Prev], 'data-style-attr': 'Slideshow_Arrow_Prev' },
			iconPrev
		),
		(0, _magicVirtualElement2.default)(
			'div',
			{ id: id + '-swiper-button-next', 'class': ['swiper-button-next', iconNext && 'swiper-no-arrow', styleClasses && styleClasses.Slideshow_Arrow_Next], 'data-style-attr': 'Slideshow_Arrow_Next' },
			iconNext
		)
	);
};

var getPagination = function getPagination(pagination, styleClasses) {
	return pagination && (0, _magicVirtualElement2.default)('div', { key: pagination, 'class': ['swiper-pagination', styleClasses && styleClasses.Slideshow_Pagination], 'data-style-attr': 'Slideshow_Pagination' });
};

var init = function init(_ref2, el) {
	var props = _ref2.props,
	    id = _ref2.id;

	var container = el.querySelector('.swiper-container');

	if (!container) {
		return;
	}

	if (container.swiper) {
		container.swiper.destroy(true, true);
		container.swiper = null;
	}

	if (props.children.length < 2) {
		return;
	}

	var swiper = new _swiper2.default(container, (0, _condenseKeys2.default)((0, _objectAssign2.default)({
		autoplay: {
			delay: props.duration,
			disableOnInteraction: props.disableOnInteraction
		},
		direction: props.direction,
		effect: props.effect,
		loop: props.loop,
		navigation: {
			nextEl: '#' + id + '-swiper-button-next',
			prevEl: '#' + id + '-swiper-button-prev'
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
			type: props.paginationType
		},
		speed: props.speed
	}, props.options)));

	if (!props.play) {
		swiper.autoplay.stop();
	}

	props.onInit(swiper);
};

var afterRender = function afterRender(_ref3, el) {
	var props = _ref3.props,
	    id = _ref3.id;
	return requestAnimationFrame(function () {
		return init({ props: props, id: id }, el);
	});
};

var shouldUpdate = function shouldUpdate(_ref4, nextProps) {
	var props = _ref4.props;
	return !(0, _deepEqual2.default)(props, nextProps);
};

var render = function render(_ref5) {
	var props = _ref5.props,
	    id = _ref5.id;

	var items = props.children.map(function (x) {
		return (0, _magicVirtualElement2.default)(
			'div',
			{ 'class': ['swiper-slide', props.styleClasses && props.styleClasses.Slideshow_Item], 'data-style-attr': 'Slideshow_Item' },
			x
		);
	});

	if (props.maintenance) {
		return (0, _magicVirtualElement2.default)(
			'div',
			{ 'class': 'swiper-maintenance' },
			props.children
		);
	}

	return (0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['swiper', props.class, props.styleClasses && props.styleClasses.Slideshow_Wrapper], 'data-style-attr': 'Slideshow_Wrapper' },
		(0, _magicVirtualElement2.default)(
			'div',
			{ 'class': ['swiper-container', props.styleClasses && props.styleClasses.Slidershow_Inner_Container], 'data-style-attr': 'Slideshow_Inner_Container' },
			(0, _magicVirtualElement2.default)(
				'div',
				{ key: props.effect, 'class': ['swiper-wrapper', 'swiper-transition--' + props.timing, props.styleClasses && props.styleClasses.Slideshow_Items_Wrapper], 'data-style-attr': 'Slidehow_Items_Wrapper' },
				items
			),
			getPagination(props.pagination, props.styleClasses)
		),
		getArrows(id, props)
	);
};

exports.default = { afterRender: afterRender, defaultProps: defaultProps, initialState: initialState, propTypes: propTypes, render: render, shouldUpdate: shouldUpdate };
